import { element, IDirective, IScope } from 'angular';

export interface IPaymentProcessFormScope extends IScope {
  config: '<';
}

export function paymentProcessFormDirective(): IDirective {

  function createInput( name, value ) {
    return element('<input>')
      .attr('name', name)
      .val(value);
  }

  return {
    scope: {
      config: '<'
    },
    link: function postLink( scope: IPaymentProcessFormScope, $element ) {
      const config = scope.config;
      Object.keys(config).forEach(( key ) => {
        const $input = createInput(key, config[ key ]);
        $element.append($input);
      });
      $element.submit();
    }
  };
}



// WEBPACK FOOTER //
// ./app/states_mobile/payment-process/directives/payment-process-form.directive.ts